import { normalizeEntityIdentifier } from './normalizeEntityIdentifier';

export function getReferenceId(value: unknown): string | undefined {
  const directIdentifier = normalizeEntityIdentifier(value);
  if (directIdentifier) {
    return directIdentifier;
  }

  if (
    value &&
    typeof value === 'object' &&
    '_id' in value
  ) {
    return normalizeEntityIdentifier(
      (value as { _id?: unknown })._id
    );
  }

  return undefined;
}

export function toReferenceId(
  value: unknown,
  fallbackValue = ''
): string {
  return getReferenceId(value) ?? fallbackValue;
}
